import {get} from 'aws-amplify/api';
import {Command, type GetMethod} from '../../Command';
import type {GetPremiumStatusResponse} from '../../../dto/user/GetPremiumStatusResponse';

export class GetPremiumStatusCommand extends Command<GetMethod, GetPremiumStatusResponse> {
  constructor() {
    super(get, {path: '/me/premium-status'});
  }

  async deserialize(output: ReturnType<typeof get>): Promise<GetPremiumStatusResponse> {
    const {body} = await output.response;
    return await (body.json() as unknown as Promise<GetPremiumStatusResponse>);
  }
}
